import { render, staticRenderFns } from "./HubSpotCallback.vue?vue&type=template&id=b55d91e0&scoped=true&"
import script from "./HubSpotCallback.vue?vue&type=script&lang=ts&"
export * from "./HubSpotCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d91e0",
  null
  
)

export default component.exports